export const FORCE_CHANGE_PASSWORD_TRANSLATE = {
    forceChangePassword: {
        title: "Cambio de contraseña",
        subtitle: "Por razones de seguridad, debe cambiar su contraseña para continuar",
        fields: {
            currentPassword: {
                label: "Contraseña actual",
                placeholder: "Ingrese su contraseña actual",
            },
            password: {
                label: "Nueva contraseña",
                placeholder: "Ingrese su nueva contraseña",
                hint: "La contraseña debe contener caracteres especiales, mayúsculas, minúsculas y números"
            },
            passwordConfirmation: {
                label: "Confirmación de nueva contraseña",
                placeholder: "Ingrese la confirmación de la nueva contraseña",
                hint: "La confirmación de contraseña debe coincidir con la nueva contraseña"
            },
        },
        actions: {
            update: "Cambiar",
            close: "Cerrar y salir"
        },
    }
};
